import React, { useState, useMemo } from 'react';
import { Table, Input } from 'antd';
import { FormattedMessage } from 'react-intl';

const SearchableTable = ({
    intl,
    data,
    selectedKeys = [],
    onSelectionChange,
    placeholderId,
    titleKey,
    searchKey = null,
    columns = null,
    rowSelectionType = 'checkbox',
    scroll = { y: 240 },
    disabled = false,
    className = '',
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredData = useMemo(
        () => {
            if (!data) return [];

            const searchField = searchKey || titleKey;
            return data.filter((item) => {
                if (!searchTerm) return true;

                if (searchField) {
                    const fieldValue = item[searchField];
                    return String(fieldValue)
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase());
                }

                if (columns) {
                    return columns.some((col) => {
                        if (!col.dataIndex) return false;
                        const value = item[col.dataIndex];
                        return String(value)
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase());
                    });
                }

                return true;
            });
        },
        [data, searchTerm, searchKey, titleKey, columns]
    );

    const filteredDataKeys = useMemo(() => filteredData.map((item) => item.key), [filteredData]);

    const tableColumns = columns || [
        {
            title: (
                <FormattedMessage
                    id={`automaticReport.list.table.${
                        titleKey === 'vehicleName' ? 'vehicles' : 'emails'
                    }`}
                />
            ),
            dataIndex: titleKey,
            render: (text) => <a>{text}</a>,
        },
    ];

    const rowSelection =
        rowSelectionType === 'none'
            ? undefined
            : {
                  type: rowSelectionType,
                  selectedRowKeys: selectedKeys,
                  //onChange: onSelectionChange,
                  onChange: (selectedRowKeys, selectedRows) => {
                      const newSelectedKeys = [
                          ...selectedKeys.filter((key) => !filteredDataKeys.includes(key)),
                          ...selectedRowKeys,
                      ];
                      onSelectionChange(newSelectedKeys, selectedRows);
                  },
                  getCheckboxProps: () => ({ disabled }),
              };

    return (
        <div className={`searchable-table ${className}`}>
            <Input
                placeholder={intl.formatMessage({
                    id: placeholderId,
                    defaultMessage: 'Search...',
                })}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ marginBottom: 10 }}
                allowClear
                disabled={disabled}
            />

            <Table
                rowSelection={rowSelection}
                columns={tableColumns}
                dataSource={filteredData}
                pagination={false}
                scroll={scroll}
                rowKey="key"
                className="searchable-table-content"
            />
        </div>
    );
};

export default SearchableTable;
